import { Component, OnInit, Input, Optional } from '@angular/core';
import { AbstractControl, ControlContainer } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-field-error-message',
    templateUrl: './field-error-message.component.html',
    styleUrls: ['./field-error-message.component.css']
})
export class FieldErrorMessageComponent {

    @Input() controlName!: string;
    @Input() maxLength: number | undefined;


    constructor(@Optional() private controlContainer: ControlContainer, private translateService: TranslateService) {
    }


    public inValid = (): boolean => {
        let formControl: AbstractControl = this.controlContainer.control?.get(this.controlName);;
        let inValid = formControl.invalid === true && formControl.touched === true;
        return inValid;
    }

    public getErrors(): string[] {
        const errors: string[] = [];
        let formControl: AbstractControl = this.controlContainer.control?.get(this.controlName);;
        if (formControl && formControl.errors) {
            for (const key in formControl.errors) {
                if (formControl.errors.hasOwnProperty(key)) {
                    let msg = '';

                    if (key === 'maxlength' && this.maxLength) {
                        let translatedText = this.translateService.instant(`validation.${key}`);
                        msg = translatedText.replace("${maxlength}", this.maxLength.toString());
                    } else {
                        msg = this.translateService.instant(`validation.${key}`);
                    }

                    errors.push(msg);
                }
            }
        }
        return errors;
    }
}
